"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.List = exports.ListContainer = exports.Arrow = exports.InputControl = exports.Select = exports.Label = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Selectstyle__Container",
  componentId: "sc-1a68z47-0"
})({
  position: 'relative'
});

exports.Container = Container;

var Label = _styledComponents["default"].label.withConfig({
  displayName: "Selectstyle__Label",
  componentId: "sc-1a68z47-1"
})(function (_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return _extends({
    display: 'inline-block',
    color: error ? theme.color.feedback.error : theme.color.neutral['02'],
    marginBottom: theme.spacing.inline['5xs']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }));
});

exports.Label = Label;

var Select = _styledComponents["default"].div.withConfig({
  displayName: "Selectstyle__Select",
  componentId: "sc-1a68z47-2"
})(function (_ref2) {
  var open = _ref2.open,
      theme = _ref2.theme;
  return _extends({
    transition: '0.3s border, 0.3s color',
    boxSizing: 'border-box',
    border: '1px solid',
    borderColor: open ? theme.color.brandPrimary.light : theme.color.neutral['04'],
    borderRadius: theme.border.radius['3xs'],
    background: theme.color.neutral['07'],
    height: theme.spacing.inline['5xl'],
    outline: 'none',
    color: open ? theme.color.brandPrimary.light : theme.color.neutral['02'],
    paddingLeft: theme.spacing.inline['4xs'],
    paddingRight: theme.spacing.inline.xl,
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative'
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }), {
    lineHeight: theme.spacing.inline['5xl'],
    '&.error': {
      borderColor: theme.color.feedback.error,
      color: theme.color.feedback.error,
      svg: {
        color: theme.color.feedback.error
      }
    }
  });
});

exports.Select = Select;

var InputControl = _styledComponents["default"].input.withConfig({
  displayName: "Selectstyle__InputControl",
  componentId: "sc-1a68z47-3"
})({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  margin: 0,
  padding: 0,
  border: 0
});

exports.InputControl = InputControl;

var Arrow = _styledComponents["default"].svg.withConfig({
  displayName: "Selectstyle__Arrow",
  componentId: "sc-1a68z47-4"
})(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      color = _ref3$theme.color;
  return {
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 0,
    color: color.brandPrimary.light,
    paddingRight: spacing.inline['4xs'],
    width: spacing.inline.xs,
    height: '100%'
  };
});

exports.Arrow = Arrow;

var ListContainer = _styledComponents["default"].div.withConfig({
  displayName: "Selectstyle__ListContainer",
  componentId: "sc-1a68z47-5"
})({
  position: 'relative',
  width: '100%',
  height: 0
});

exports.ListContainer = ListContainer;

var List = _styledComponents["default"].ul.withConfig({
  displayName: "Selectstyle__List",
  componentId: "sc-1a68z47-6"
})(function (_ref4) {
  var open = _ref4.open,
      color = _ref4.theme.color;
  return {
    background: color.neutral['08'],
    display: open ? 'block' : 'none',
    boxSizing: 'border-box',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    position: 'absolute',
    left: 0,
    width: '100%',
    top: 0,
    zIndex: 1
  };
});

exports.List = List;

var Item = _styledComponents["default"].li.withConfig({
  displayName: "Selectstyle__Item",
  componentId: "sc-1a68z47-7"
})(function (_ref5) {
  var theme = _ref5.theme;
  return _extends({
    background: theme.color.neutral['08'],
    border: "1px solid ".concat(theme.color.neutral['06']),
    padding: "".concat(theme.spacing.inline['4xs'], " ").concat(theme.spacing.inline['3xs']),
    cursor: 'pointer',
    color: theme.color.neutral['02']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }), {
    '&.active': {
      background: theme.color.brandPrimary.medium,
      color: theme.color.neutral['08']
    },
    ':not(.active):hover': {
      background: "".concat(theme.color.brandPrimary.light, "0d")
    }
  });
});

exports.Item = Item;